import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { CCUFSA_EVENT } from '@/data/events';

export const EventBanner = () => {
  return (
    <section className="relative py-16 md:py-24">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-[2rem] gradient-leaf text-primary-foreground shadow-pop"
        >
          <div className="absolute inset-0 bg-noise opacity-[0.04]" />
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-accent/30 blur-3xl" />
          <div className="absolute -bottom-32 -left-20 h-72 w-72 rounded-full bg-primary-glow/25 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-8 p-8 sm:p-12 lg:p-14 items-center">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-foreground/10 text-xs uppercase tracking-[0.18em]">
                <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse" /> Coming up · {CCUFSA_EVENT.hashtag}
              </div>
              <h3 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium mt-4 leading-[1.05] text-balance">
                Meet us at the 2026 CCUFSA<br/>
                <span className="italic font-light text-accent">National Conference in Ottawa.</span>
              </h3>

              <div className="mt-6 flex flex-wrap gap-5 text-sm">
                <div className="flex items-center gap-2 text-primary-foreground/90"><Calendar className="h-4 w-4 text-accent" /> {CCUFSA_EVENT.date}</div>
                <div className="flex items-center gap-2 text-primary-foreground/90"><MapPin className="h-4 w-4 text-accent" /> {CCUFSA_EVENT.venue}, {CCUFSA_EVENT.city}</div>
              </div>

              <div className="mt-8 flex flex-wrap gap-3">
                <Button asChild className="rounded-full bg-accent text-accent-foreground hover:bg-accent/90 px-6 h-12">
                  <Link to="/events">See conference details <ArrowRight className="ml-1.5 h-4 w-4" /></Link>
                </Button>
                <Button asChild variant="outline" className="rounded-full border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 px-6 h-12 bg-transparent">
                  <a href={CCUFSA_EVENT.link} target="_blank" rel="noopener noreferrer">Register</a>
                </Button>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="bg-primary-foreground rounded-3xl p-5 shadow-pop">
                <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground text-center">Official conference</div>
                <div className="mt-3 rounded-2xl bg-secondary/30 p-5 grid place-items-center min-h-[200px]">
                  <img
                    src={CCUFSA_EVENT.ccufsaLogo}
                    alt="2026 CCUFSA National Conference"
                    className="max-h-[180px] max-w-full object-contain"
                  />
                </div>
                <div className="text-center mt-3">
                  <div className="font-display text-lg font-semibold text-primary">Ottawa · June 23–28, 2026</div>
                  <div className="text-xs text-muted-foreground mt-0.5">Delta Hotels City Centre</div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EventBanner;
